import { render, staticRenderFns } from "./LessonExam.vue?vue&type=template&id=263210b4&scoped=true"
import script from "./LessonExam.vue?vue&type=script&lang=js"
export * from "./LessonExam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263210b4",
  null
  
)

export default component.exports